var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.dst2{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.dst3{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.43,
    y: -0.82,
    className: "dst2",
    width: 360,
    height: 360
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dst3",
    d: "M258.31,230.36c2.22-4.88,7.93-7.01,12.74-4.76c4.81,2.25,6.91,8.04,4.69,12.93 c-11.24,24.73-29.29,45.63-51.71,60.2c-21.75,14.14-47.6,22.34-75.28,22.34c-38.6,0-73.55-15.88-98.85-41.56 C24.61,253.83,8.96,218.35,8.96,179.18c0-39.18,15.65-74.65,40.94-100.33c25.3-25.68,60.25-41.56,98.85-41.56 c27.55,0,53.29,8.14,75,22.18c22.4,14.49,40.47,35.25,51.75,59.8c2.24,4.88,0.15,10.69-4.66,12.96 c-4.81,2.27-10.52,0.16-12.77-4.73c-9.77-21.26-25.34-39.18-44.61-51.65c-18.66-12.06-40.86-19.05-64.72-19.05 c-33.29,0-63.44,13.7-85.25,35.84c-21.82,22.14-35.31,52.74-35.31,86.53c0,33.78,13.5,64.39,35.31,86.53 c21.82,22.14,51.96,35.84,85.25,35.84c23.93,0,46.21-7.05,64.91-19.21C233.02,269.76,248.62,251.71,258.31,230.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dst3",
    d: "M295.83,142.18l51.74,36.51c1.71,1.2,2.13,3.6,0.94,5.34c-0.32,0.47-0.74,0.84-1.2,1.12l-51.64,36.68 c-1.7,1.2-4.06,0.78-5.24-0.95c-0.46-0.66-0.68-1.43-0.68-2.19h-0.01v-18.09H116.78c-9.73,0-17.7-8.09-17.7-17.97l0,0 c0-9.88,7.97-17.97,17.7-17.97h172.96v-19.42c0-2.12,1.69-3.84,3.78-3.84C294.39,141.39,295.19,141.68,295.83,142.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8509b7dcf87ab971d383751e88a71d42.svg";
export { ForwardRef as ReactComponent };